import BaseController from "controllers/base"

class Controller extends BaseController {
  call() {
    super.call()
    bindRemoveDocument.call(this)
    bindArchive.call(this)
  }
};

let bindArchive = function() {
  this.root.find("#archive-btn").on('click', (e) => {
    let removalUrl = e.currentTarget.dataset.url

    swal({
      title: "Are you sure you want to archive this proposal?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: `Sure`,
    }).then((confirm) => {
      if (confirm.value === true) {
        $.ajax({
          url: removalUrl,
          method: "PUT",
          dataType: "json"
        }).done((response) => {
          window.location = response.redirect_path
        })
      }
    })
  })
}

let bindRemoveDocument = function() {
  this.root.find(".remove-document").on('click', (e) => {
    let documentItem = $(e.currentTarget).closest('.document-item')
    let removalUrl = e.currentTarget.dataset.url

    swal({
      title: "Are you sure you want to remove this document?",
      html: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: `Done`,
    }).then((confirm) => {
      if (confirm.value === true) {
        $.ajax({
          url: removalUrl,
          method: "DELETE",
          dataType: "json"
        }).done((response) => {
          documentItem.remove()
        })
      }
    })
  })
}

export default Controller;
